import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const documentTypesAdapter = getAdapter();

const documentTypesSlice = createSlice({
  name: 'documentTypes',
  initialState: documentTypesAdapter.getInitialState(),
  reducers: {
    setDocumentTypes: (state, { payload: { documentTypes } }) => {
      documentTypesAdapter.setAll(state, documentTypes);
    },
  },
});

const selectors = documentTypesAdapter.getSelectors(({ documentTypes }) => documentTypes);

export const getDocumentTypesIncludingDeleted = (state) => selectors.selectAll(state);

export const getDocumentTypes = (state) => getDocumentTypesIncludingDeleted(state)
  .filter(({ deleted }) => !deleted);

export const {
  setDocumentTypes,
} = documentTypesSlice.actions;

export default documentTypesSlice.reducer;
